var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$vuetify.breakpoint.smAndDown)?_c('v-container',{attrs:{"id":"section-11","fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"text-h6 py-16 font-weight-regular text-center",staticStyle:{"letter-spacing":"2px !important"},attrs:{"id":"mobile-main"}},[_vm._v(" "+_vm._s(_vm.$t('section1.description'))+" ")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }